export default __webpack_public_path__ + "assets/mp4.c631e40ab77a5009bec629505396f88b.png";